import imgExit from '@assets/web-v3-images/icons/exits.png';
import backgroundBottom from '@assets/web-v3-images/ui-popup-bottom1.png';
import backgroundCenter from '@assets/web-v3-images/ui-popup-center1.png';
import backgroundTop from '@assets/web-v3-images/ui-popup-top1.png';
import Popups from '..';
import { Dialog } from '@radix-ui/themes';

//UI-1 dùng cho các popup có nền trắng như rule, no connection, Something ,Not Lowest Unique ,Out of Turns,.....
export default function PopupFrame({ open, onOpenChange = () => { }, title, children, classNames, disableOutsideClose }) {
	return (
		<Popups
			open={open}
			onOpenChange={onOpenChange}
			className={`!bg-transparent !shadow-none !p-0 ${classNames}`}
			disableOutsideClose={disableOutsideClose}
		>
			{title &&
				<Dialog.Title
					className="absolute z-1 left-1/2 -translate-x-1/2 top-4 sm:top-5 md:top-5 lg:top-5 xl:top-5
						!text-[16px] sm:!text-[29px]
					 	font-black leading-none text-[#FCF8E9] w-[70%] text-center"
					style={{
						textShadow: `
							0 8px 12px rgba(208,69,14,.35),
							0 4px 6px rgba(208,69,14,.45)
						`,
					}}
				>
					{title}
				</Dialog.Title>
			}
			<div className="flex flex-col w-full relative">
				<img src={imgExit} className="w-[10%] h-auto absolute top-[7px] right-[7px] btn-click-active" onClick={() => onOpenChange(!open)} alt="" />
				{/* Khung 3 mảnh: nắp trên + thân lặp + nắp dưới. Cả 3 ảnh rộng 100% và
				    viền cam khớp đúng cột (đã verify 4.09%..96.08% ở cả 3) nên co giãn
				    theo bề rộng vẫn thẳng hàng. -mt-0.5 ở thân & nắp dưới để CHỒNG MÍ
				    ~2px, che đường hở lẻ pixel tại mối nối khi ảnh cao lẻ ở mỗi bề rộng
				    (mảnh vẽ sau trong DOM đè lên mảnh trước -> mí liền mạch). */}
				<img src={backgroundTop} className="block w-full" alt="" />
				<div
					className="relative z-2 -mt-0.5 w-full min-h-[200px]"
					style={{
						backgroundImage: `url(${backgroundCenter})`,
						backgroundRepeat: "repeat-y",
						backgroundSize: "100% auto",
						backgroundPosition: "bottom center",
					}}
				>
					<div className="
							max-h-[75vh] 
							overflow-y-auto 
							scrollbar-h-2
							scrollbar-thin
							scrollbar-thumb-[#E6B97D]
							scrollbar-track-transparent
							mx-[5%]
							px-[4%]
							">
						<div className='pb-4'>
							{children}
						</div>
					</div>
				</div>

				<img src={backgroundBottom} className="-mt-0.5 block w-full" alt="" />
			</div>
		</Popups>
	)
}

export function BgContentPopup({ children, onOpenChange, open }) {
	return (
		<div className="flex flex-col w-full relative">
			{/* <img src={imgExit} className="w-[10%] h-auto absolute top-[7px] right-[7px] btn-click-active" onClick={() => onOpenChange(!open)} alt="" /> */}
			{/* Khung 3 mảnh: nắp trên + thân lặp + nắp dưới. Cả 3 ảnh rộng 100% và
				    viền cam khớp đúng cột (đã verify 4.09%..96.08% ở cả 3) nên co giãn
				    theo bề rộng vẫn thẳng hàng. -mt-0.5 ở thân & nắp dưới để CHỒNG MÍ
				    ~2px, che đường hở lẻ pixel tại mối nối khi ảnh cao lẻ ở mỗi bề rộng
				    (mảnh vẽ sau trong DOM đè lên mảnh trước -> mí liền mạch). */}
			<img src={backgroundTop} className="block w-full" alt="" />
			<div
				className="relative z-2 -mt-0.5 w-full min-h-[200px]"
				style={{
					backgroundImage: `url(${backgroundCenter})`,
					backgroundRepeat: "repeat-y",
					backgroundSize: "100% auto",
					backgroundPosition: "bottom center",
				}}
			>
				<div className="
							max-h-[75vh] 
							overflow-y-auto 
							scrollbar-h-2
							scrollbar-thin
							scrollbar-thumb-[#E6B97D]
							scrollbar-track-transparent
							mx-[5%]
							px-[4%]
							">
					<div className='pb-4'>
						{children}
					</div>
				</div>
			</div>

			<img src={backgroundBottom} className="-mt-0.5 block w-full" alt="" />
		</div>
	)
}